/*
 * !
 *  * Copyright (c) Pro3W 2024
 *  * author: Sławomir Moskal
 *  * project: dev.cms.pro3w.pl
 *  * filename: js_head.js
 *  * last update: 25.01.2024, 22:24
 *
 */
//Open StreetView Map
import L from "leaflet";

window.L = L;

//Import Swiper as module
import Swiper from "swiper/bundle";

window.Swiper = Swiper;

//Import Jquery as module
$ = require("jquery");
window.jQuery = $;
global.$ = global.jQuery = $;


import "hotkeys-js";

hotkeys("shift+s", {keydown: true, keyup: true}, function (event, handler) {
    if (event.type === "keydown") {
        document.getElementById("search-top-input").focus();
        document.getElementById("search-top").classList += " focus-on ";
        document.getElementById("search-top-info").classList += " d-none ";
        return false;
    }
});


// import select2 from 'select2';
//
// $.fn.select2 = select2;

// Import all of Bootstrap's JS

import * as bootstrap from "bootstrap";

window.bootstrap = bootstrap;
// global.bootstrap = window.bootstrap = require("bootstrap");


document.addEventListener('DOMContentLoaded', (event) => {
    var tooltips = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltips.map(function (tooltip) {
        return new bootstrap.Tooltip(tooltip);
    });
});

//UA-Parser - show OS

// import UAParser from "ua-parser-js";
// window.UAParser = UAParser;

import {UAParser} from 'ua-parser-js';

window.UAParser = UAParser


// import "jquery-validation";

var bootbox = require("bootbox");
window.bootbox = bootbox;

import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
// import 'photoswipe/style.css';


window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeLightbox = PhotoSwipeLightbox;

import ObjectPosition from "@vovayatsyuk/photoswipe-object-position";

window.ObjectPosition = ObjectPosition;

//
// const lightbox = new PhotoSwipeLightbox({
//     gallery: "#my-gallery",
//     children: "a",
//     pswpModule: () => import("photoswipe"),
// });
// lightbox.init();

import Headroom from 'headroom.js';

document.addEventListener("DOMContentLoaded", function (event) {
    const myElement = document.body;
    const headroom = new Headroom(myElement, {
        offset: 80,
        onTop: function () {
            myElement.classList.remove('header-sticky');
        },
        onNotTop: function () {
            myElement.classList.add('header-sticky');
        }
    });
    headroom.init();

});


import * as Popper from '@popperjs/core';

window.Popper = Popper;

//TODO: tempus jest wsadzony w index na sztywno w edycji - trzeba go tu uruchomić
// date time picker and range picker in future

// import {TempusDominus} from '@eonasdan/tempus-dominus';
//
// window.TempusDominus = TempusDominus;

// import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';
// import * as TempusDominus from '@eonasdan/tempus-dominus';

// window.TempusDominus = TempusDominus;
//
// import './algolia.js';

//TODO: dodać masonry i imagesloaded
// import * as imagesLoaded from "imagesloaded";
//
// global.imagesLoaded = imagesLoaded;
// window.imagesLoaded = imagesLoaded;
//
// import * as masonry from "masonry-layout";
//
// global.masonry = masonry;
// window.masonry = masonry;